import React from 'react';
import BaseLayout from '../../../common/layouts/BaseLayout';
import HeadShared from '../../../common/HeadShared';
import styles from '../../../common/utils/styles/css/styles';
import { css } from 'styled-components';
import Link from '../../../common/components/basic/Link';
import { MaxWidth } from '../../../common/base';
import SigninFormContainer from '../components/SigninFormContainer';

export default function SigninPage() {
  return (
    <BaseLayout blank>
      <HeadShared title="RupiahToken - Login" desc="Rupiah Token Login Page" />
      <div
        css={[
          styles.flex,
          styles.flexDirRow,
          css`
            height: 100vh;
          `
        ]}
      >
        <div
          css={[
            styles.flex1,
            css`
              ${MaxWidth.md`display: none;`}
              background-color: ${({ theme: { colors } }) => colors.primary.light};
            `
          ]}
        >
          <img
            css={css`
              position: absolute;
              left: 0;
              bottom: 0;
            `}
            src="/static/images/illustrations/signin.svg"
            alt="Illustration - Signin"
          />
          <Link href="/">
            <img
              css={css`
                margin: 100px;
              `}
              src="/static/images/logo/logo-rpt.svg"
              alt="Logo"
              width={340}
            />
          </Link>
        </div>
        <div css={[styles.flex1]}>
          <div
            css={[
              styles.flexMiddle,
              css`
                height: 100%;
              `
            ]}
          >
            <div
              css={css`
                width: 80%;
                ${MaxWidth.md`
                  width: 100%;
                  padding: 20px;
                `}
              `}
            >
              <SigninFormContainer />
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}
